module.exports = __webpack_public_path__ + "static/media/Lateral_Normal_Z2.b4528772.png";